import { render, staticRenderFns } from "./CmsFooter.vue?vue&type=template&id=4605ccdc&scoped=true"
import script from "./CmsFooter.vue?vue&type=script&lang=js"
export * from "./CmsFooter.vue?vue&type=script&lang=js"
import style0 from "./CmsFooter.vue?vue&type=style&index=0&id=4605ccdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605ccdc",
  null
  
)

export default component.exports